<!-- Breadcrumb, título e conteúdo -->
<div class="atricon-navbar">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item active">Controlador</li>
        </ol>
    </nav>
    <div class="d-flex justify-content-between align-items-center header-desktop">
        <h3 class="titulo"><b>Controlador – IMAP</b> – {{desNomeOrg}}</h3>
        <div class="topbar">
            <!-- Busca -->
            <div class="search-container">
                <span class="material-icons search-icon">search</span>

                <input type="text" class="form-control search-input" placeholder="Buscar" matInput
                    [formControl]="perguntaControl" [matAutocomplete]="auto">

                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSearch($event.option.value)">
                    <mat-option *ngFor="let option of filteredPerguntas | async" [value]="option">
                        {{ option }}
                    </mat-option>
                </mat-autocomplete>
            </div>


            <!-- Dropdown Entidades -->
            <div class="dropdown ms-2">
                <button class="dropdown-btn dropdown-toggle" type="button" data-bs-toggle="dropdown">
                    <div class="icon-entidade"></div> Entidades
                </button>
                <ul class="dropdown-menu dropdown-menu-entity" data-bs-auto-close="false"
                    style="width: 380px !important; background-color: var(--white-color)">
                    <li>
                        <div class="row g-3">
                            <div class="col-sm-6">
                                <ng-select [(ngModel)]="codEstadoEst" [items]="estado" bindLabel="desNomeEstadoEst"
                                    bindValue="codEstadoEst" placeholder="Estado" (change)="onChangeEstado()"
                                    [searchFn]="customSearchEstado" [clearable]="true" class="form-select"
                                    notFoundText="Nenhum Estado encontrado" [searchable]="true">
                                </ng-select>
                            </div>

                            <div class="col-sm-5">
                                <ng-select [(ngModel)]="codMunicipioMun" [items]="municipio" bindLabel="desNomeMun"
                                    bindValue="codMunicipioMun" placeholder="Município" (change)="onMunicipioChange()"
                                    [searchFn]="customSearchMunicipio" [clearable]="true" class="form-select"
                                    notFoundText="Nenhum Município encontrado" [searchable]="true"
                                    [disabled]="!codEstadoEst">
                                </ng-select>
                            </div>
                        </div>
                    </li>

                    <li class="d-flex mb-2 justify-content-between border-0" *ngIf="countAlerta !== 0">
                        <span>Dimensão</span>
                        <span class="badge-alerta">{{countAlerta}} alertas nas dimensões</span>
                    </li>
                    <div class="divider"></div>
                    <li class="clickable" *ngFor="let item of dimensoesPorMunicipio"
                        (click)="confirmChangeOrgao(item.codOrgaoOrg, item.desNomeOrg)">
                        <div>
                            <div class="entity-icon">**</div>
                            <div class="entity-text">
                                <strong>{{item.desNomeOrg}}</strong>
                                <small>{{item.criteriosAtendidos}}/{{item.totalCriterios}} itens abastecidos</small>
                            </div>
                        </div>
                        <span [ngClass]="item.alerta === 'Dentro do Padrão' ? 'status-normal' : 'status-critico'">
                            {{ item.alerta }}
                        </span>
                    </li>
                    <div class="divider"></div>
                    <li class="mt-3 border-0">
                        <button class="btn btn-primary-dimensao w-100" (click)="changeToFirstOrgao()">IR PARA DIMENSÃO
                            DA TRANSPARÊNCIA</button>
                    </li>
                </ul>
            </div>

            <!-- Notificações -->
            <div class="d-flex align-items-center gap-3 ms-2">
                <div class="dropdown">
                    <button class="btn btn-link p-0 position-relative" id="notifDropdown" data-bs-toggle="dropdown"
                        aria-expanded="false" title="Notificações">
                        <span class="material-icons  icons-searchbar fs-4">notifications</span>
                        <span
                            class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle">
                            <span class="visually-hidden">Nova notificação</span>
                        </span>
                    </button>

                    <div class="dropdown-menu dropdown-menu-end notification-dropdown p-3"
                        aria-labelledby="notifDropdown">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h6 class="fw-bold mb-0 text-historico">Histórico de manifestação</h6>
                            <button href="#" class="fw-semibold small btn-ver-todos">Ver todos</button>
                        </div>

                        <div class="notification-item mb-3">
                            <img src="../../../assets/images/image-notificacao.png" class="notif-icon" />
                            <div class="notif-content">
                                <div class="notif-title">Receita</div>
                                <div class="notif-sub">1.1 receitas e despesas</div>
                            </div>
                            <div class="notif-time text-danger fw-semibold">⧫ 72 horas em atraso</div>
                        </div>

                        <!-- Demais notificações -->
                        <div class="notification-item1">
                            <img src="../../../assets/images/image-sub.png" class="notif-icon" />
                            <div class="notif-content">
                                <div class="notif-title">Sic</div>
                                <div class="notif-sub">1.1 receitas e despesas</div>
                            </div>
                            <div class="notif-time fw-semibold">⧫ 82 horas para responder</div>
                        </div>

                        <div class="notification-item1">
                            <img src="../../../assets/images/image-sub.png" class="notif-icon" />
                            <div class="notif-content">
                                <div class="notif-title">Ouvidoria</div>
                                <div class="notif-sub">1.1 receitas e despesas</div>
                            </div>
                            <div class="notif-time fw-semibold">⧫ 82 horas para responder</div>
                        </div>

                        <div class="notification-item1">
                            <img src="../../../assets/images/image-sub.png" class="notif-icon" />
                            <div class="notif-content">
                                <div class="notif-title">Dados parlamentares</div>
                                <div class="notif-sub">1.1 receitas e despesas</div>
                            </div>
                            <div class="notif-time fw-semibold">⧫ 82 horas para responder</div>
                        </div>

                        <div class="notification-item1">
                            <img src="../../../assets/images/image-sub.png" class="notif-icon" />
                            <div class="notif-content">
                                <div class="notif-title">Possui sítio?</div>
                                <div class="notif-sub">1.1 receitas e despesas</div>
                            </div>
                            <div class="notif-time fw-semibold">⧫ 82 horas para responder</div>
                        </div>
                    </div>
                </div>

                <!-- Dark Mode -->
                <button class="btn btn-link text-secondary p-0" title="{{ darkmode ? 'Modo claro' : 'Modo escuro' }}"
                    (click)="modetoggle()">
                    <span class="material-icons icons-searchbar">dark_mode</span>
                </button>

                <!-- Informações -->
                <div class="dropdown">
                    <button class="btn btn-link text-secondary p-0" id="infoDropdown" data-bs-toggle="dropdown"
                        aria-expanded="false" title="Informações">
                        <span class="material-icons icons-searchbar">info</span>
                    </button>

                    <div class="dropdown-menu dropdown-menu-end p-3 info-box" aria-labelledby="infoDropdown">
                        <div class="d-flex align-items-center gap-3">
                            <div class="info-img">
                                <img src="../../../assets/images/illustration-info.png" alt="Ilustração do protótipo"
                                    class="img-fluid" />
                            </div>
                            <div class="info-text">
                                <div>Versão beta 0.1</div>
                                <div class="small">data: 08/08/2025</div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Foto do Perfil -->
                <!-- Perfil com dropdown -->
                <div class="dropdown">
                    <button class="btn p-0 border-0 bg-transparent" id="profileDropdown" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <div class="position-relative">
                            <img src="../../../assets/images/foto-perfil.png" class="profile-pic" />
                            <div class="dot-status"></div>
                        </div>
                    </button>

                    <div class=" custom-dropdown dropdown-menu dropdown-menu-end p-0 text-end"
                        aria-labelledby="profileDropdown">
                        <button
                            class="btn btn-dark btn-sm d-flex align-items-center gap-2 px-3 py-2 rounded-pill btn-logout">
                            <span class="material-icons logout-icon">logout</span>
                            <span (click)="logout()">Sair</span>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- HEADER MOBILE -->
    <div class="header-mobile  p-2">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <div>
                <h4 class="titulo"><b>Controlador – IMAP</b><br> – {{desNomeOrg}}</h4>
            </div>

            <div class="d-flex align-items-center gap-2">
                <div class=" dropdown ms-2">
                    <button class="btn-icon m-auto" type="button" data-bs-toggle="dropdown">
                        <div class="icon-entidade"></div>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-entity" data-bs-auto-close="false"
                        style="width: 380px !important; background-color: var(--white-color)">
                        <li>
                            <div class="row g-3">
                                <div class="col-sm-6">
                                    <ng-select [(ngModel)]="codEstadoEst" [items]="estado" bindLabel="desNomeEstadoEst"
                                        bindValue="codEstadoEst" placeholder="Estado" (change)="onChangeEstado()"
                                        [searchFn]="customSearchEstado" [clearable]="true" class="form-select"
                                        notFoundText="Nenhum Estado encontrado" [searchable]="true">
                                    </ng-select>
                                </div>

                                <div class="col-sm-5">
                                    <ng-select [(ngModel)]="codMunicipioMun" [items]="municipio" bindLabel="desNomeMun"
                                        bindValue="codMunicipioMun" placeholder="Município"
                                        (change)="onMunicipioChange()" [searchFn]="customSearchMunicipio"
                                        [clearable]="true" class="form-select"
                                        notFoundText="Nenhum Município encontrado" [searchable]="true"
                                        [disabled]="!codEstadoEst">
                                    </ng-select>
                                </div>
                            </div>
                        </li>

                        <li class="d-flex mb-2 justify-content-between border-0" *ngIf="countAlerta !== 0">
                            <span>Dimensão</span>
                            <span class="badge-alerta">{{countAlerta}} alertas nas dimensões</span>
                        </li>
                        <div class="divider"></div>
                        <li class="clickable" *ngFor="let item of dimensoesPorMunicipio"
                            (click)="confirmChangeOrgao(item.codOrgaoOrg, item.desNomeOrg)">
                            <div>
                                <div class="entity-icon">**</div>
                                <div class="entity-text">
                                    <strong>{{item.desNomeOrg}}</strong>
                                    <small>{{item.criteriosAtendidos}}/{{item.totalCriterios}} itens abastecidos</small>
                                </div>
                            </div>
                            <span [ngClass]="item.alerta === 'Dentro do Padrão' ? 'status-normal' : 'status-critico'">
                                {{ item.alerta }}
                            </span>
                        </li>
                        <div class="divider"></div>
                        <li class="mt-3 border-0">
                            <button class="btn btn-primary-dimensao w-100" (click)="changeToFirstOrgao()">IR PARA
                                DIMENSÃO
                                DA TRANSPARÊNCIA</button>
                        </li>
                    </ul>
                </div>

                <button class="btn-icon">
                    <div class="dropdown">
                        <button class="btn btn-link p-0 position-relative" id="notifDropdown" data-bs-toggle="dropdown"
                            aria-expanded="false" title="Notificações">
                            <span class="material-icons  icons-searchbar fs-4">notifications</span>
                            <span
                                class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle">
                                <span class="visually-hidden">Nova notificação</span>
                            </span>
                        </button>

                        <div class="dropdown-menu dropdown-menu-end notification-dropdown p-3"
                            aria-labelledby="notifDropdown">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h6 class="fw-bold mb-0 text-historico">Histórico de manifestação</h6>
                                <button href="#" class="fw-semibold small btn-ver-todos">Ver todos</button>
                            </div>

                            <div class="notification-item mb-3">
                                <img src="../../../assets/images/image-notificacao.png" class="notif-icon" />
                                <div class="notif-content">
                                    <div class="notif-title">Receita</div>
                                    <div class="notif-sub">1.1 receitas e despesas</div>
                                </div>
                                <div class="notif-time text-danger fw-semibold">⧫ 72 horas em atraso</div>
                            </div>

                            <!-- Demais notificações -->
                            <div class="notification-item1">
                                <img src="../../../assets/images/image-sub.png" class="notif-icon" />
                                <div class="notif-content">
                                    <div class="notif-title">Sic</div>
                                    <div class="notif-sub">1.1 receitas e despesas</div>
                                </div>
                                <div class="notif-time fw-semibold">⧫ 82 horas para responder</div>
                            </div>

                            <div class="notification-item1">
                                <img src="../../../assets/images/image-sub.png" class="notif-icon" />
                                <div class="notif-content">
                                    <div class="notif-title">Ouvidoria</div>
                                    <div class="notif-sub">1.1 receitas e despesas</div>
                                </div>
                                <div class="notif-time fw-semibold">⧫ 82 horas para responder</div>
                            </div>

                            <div class="notification-item1">
                                <img src="../../../assets/images/image-sub.png" class="notif-icon" />
                                <div class="notif-content">
                                    <div class="notif-title">Dados parlamentares</div>
                                    <div class="notif-sub">1.1 receitas e despesas</div>
                                </div>
                                <div class="notif-time fw-semibold">⧫ 82 horas para responder</div>
                            </div>

                            <div class="notification-item1">
                                <img src="../../../assets/images/image-sub.png" class="notif-icon" />
                                <div class="notif-content">
                                    <div class="notif-title">Possui sítio?</div>
                                    <div class="notif-sub">1.1 receitas e despesas</div>
                                </div>
                                <div class="notif-time fw-semibold">⧫ 82 horas para responder</div>
                            </div>
                        </div>
                    </div>
                </button>

                <button class="btn-icon text-secondary p-0" title="{{ darkmode ? 'Modo claro' : 'Modo escuro' }}"
                    (click)="modetoggle()">
                    <span class="material-icons icons-searchbar">dark_mode</span>
                </button>

                <button class="btn-icon">
                    <div class="dropdown">
                        <button class="btn text-secondary p-0" id="infoDropdown" data-bs-toggle="dropdown"
                            aria-expanded="false" title="Informações">
                            <span class="material-icons icons-searchbar">info</span>
                        </button>

                        <div class="dropdown-menu dropdown-menu-end p-3 info-box" aria-labelledby="infoDropdown">
                            <div class="d-flex align-items-center gap-3">
                                <div class="info-img">
                                    <img src="../../../assets/images/illustration-info.png"
                                        alt="Ilustração do protótipo" class="img-fluid" />
                                </div>
                                <div class="info-text">
                                    <div>Versão beta 0.1</div>
                                    <div class="small">data: 08/08/2025</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </button>

                <div class="profile position-relative">
                    <div class="dropdown">
                        <button class="btn p-0 border-0 bg-transparent" id="profileDropdown" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <div class="position-relative">
                                <img src="../../../assets/images/foto-perfil.png" class="profile-pic" />
                                <div class="dot-status"></div>
                            </div>
                        </button>

                        <div class=" custom-dropdown dropdown-menu dropdown-menu-end p-0 text-end"
                            aria-labelledby="profileDropdown">
                            <button
                                class="btn btn-dark btn-sm d-flex align-items-center gap-2 px-3 py-2 rounded-pill btn-logout">
                                <span class="material-icons logout-icon">logout</span>
                                <span>Sair</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="search-container w-100">
            <span class="material-icons search-icon">search</span>
            <input type="text" placeholder="Buscar" class="search-input" />
        </div>
    </div>
</div>
